<template>
 <v-card
   class="business-card"
   :class="{ 'card-hover': active }"
   elevation="0"
   @mouseover="active = true"
   @mouseleave="active = false"
 >
   <!-- Background Elements -->
   <div class="card-background">
     <div class="bg-pattern"></div>
     <div class="gradient-overlay"></div>
   </div>


   <!-- Header Section -->
   <div class="card-header">
     <div class="header-content">
       <div class="icon-container">
         <v-icon size="32" color="white">mdi-office-building</v-icon>
       </div>
       <div class="header-text">
         <h2 class="card-title">Business Analytics</h2>
         <p class="card-subtitle">Monitor and track registered business entities</p>
       </div>
     </div>
     <div class="header-decoration">
       <div class="deco-circle"></div>
       <div class="deco-circle"></div>
     </div>
   </div>


   <!-- Stats Grid -->
   <div class="stats-container">
     <div class="stats-grid">
       <!-- Registered -->
       <div
         class="stat-card registered-card"
         @click="goToBusiness('Registered')"
         :class="{ 'stat-hover': hoveredStat === 'registered' }"
         @mouseover="hoveredStat = 'registered'"
         @mouseleave="hoveredStat = null"
       >
         <div class="stat-icon">
           <v-icon size="24" color="#4CAF50">mdi-check-circle</v-icon>
         </div>
         <div class="stat-content">
           <div class="stat-number registered-number">
             {{ getCompanyCount.registeredCompanies }}
           </div>
           <div class="stat-label">Registered</div>
         </div>
         <div class="stat-trend">
           <v-icon size="16" color="#4CAF50">mdi-trending-up</v-icon>
         </div>
       </div>


       <!-- Pending -->
       <div
         class="stat-card pending-card"
         @click="goToBusiness('Pending')"
         :class="{ 'stat-hover': hoveredStat === 'pending' }"
         @mouseover="hoveredStat = 'pending'"
         @mouseleave="hoveredStat = null"
       >
         <div class="stat-icon">
           <v-icon size="24" color="#FF9800">mdi-clock-outline</v-icon>
         </div>
         <div class="stat-content">
           <div class="stat-number pending-number">
             {{ getCompanyCount.pendingCompanies }}
           </div>
           <div class="stat-label">Awaiting Approval</div>
         </div>
         <div class="stat-indicator pending-pulse"></div>
       </div>


       <!-- Approved -->
       <div
         class="stat-card approved-card"
         @click="goToBusiness('Available')"
         :class="{ 'stat-hover': hoveredStat === 'approved' }"
         @mouseover="hoveredStat = 'approved'"
         @mouseleave="hoveredStat = null"
       >
         <div class="stat-icon">
           <v-icon size="24" color="#2196F3">mdi-shield-check</v-icon>
         </div>
         <div class="stat-content">
           <div class="stat-number approved-number">
             {{ getCompanyCount.availableCompanies }}
           </div>
           <div class="stat-label">Approved</div>
         </div>
         <div class="stat-badge">
           <span>Active</span>
         </div>
       </div>


       <!-- Rejected -->
       <div
         class="stat-card rejected-card"
         @click="goToBusiness('Rejected')"
         :class="{ 'stat-hover': hoveredStat === 'rejected' }"
         @mouseover="hoveredStat = 'rejected'"
         @mouseleave="hoveredStat = null"
       >
         <div class="stat-icon">
           <v-icon size="24" color="#F44336">mdi-close-circle</v-icon>
         </div>
         <div class="stat-content">
           <div class="stat-number rejected-number">
             {{ getCompanyCount.rejectedCompanies }}
           </div>
           <div class="stat-label">Rejected</div>
         </div>
         <div class="stat-warning">
           <v-icon size="14" color="#F44336">mdi-alert-circle</v-icon>
         </div>
       </div>
     </div>
   </div>


   <!-- Summary Section -->
   <!-- <div class="summary-section">
     <div class="summary-item">
       <v-icon size="20" color="#666">mdi-chart-line</v-icon>
       <span class="summary-text">
         Total: {{ getTotalCount }}
       </span>
     </div>
     <div class="summary-item">
       <v-icon size="20" color="#666">mdi-percent</v-icon>
       <span class="summary-text">
         Approval Rate: {{ getApprovalRate }}%
       </span>
     </div>
     <v-btn
       size="small"
       variant="outlined"
       class="view-all-btn"
       @click="goToBusiness('Registered')"
     >
       <v-icon left size="16">mdi-eye</v-icon>
       View All
     </v-btn>
   </div> -->


   <!-- Loading Overlay -->
   <div v-if="loading" class="loading-overlay">
     <v-progress-circular
       indeterminate
       size="40"
       color="primary"
     ></v-progress-circular>
   </div>
 </v-card>
</template>


<script>
import { mapGetters, mapActions } from "vuex";


export default {
 data() {
   return {
     active: false,
     hoveredStat: null,
     loading: false
   };
 },
 computed: {
   ...mapGetters("adminDashboard", ["getCompanyCount"]),
  
   getTotalCount() {
     const counts = this.getCompanyCount;
     return (counts.registeredCompanies || 0) +
            (counts.pendingCompanies || 0) +
            (counts.availableCompanies || 0) +
            (counts.rejectedCompanies || 0);
   },
  
   getApprovalRate() {
     const total = this.getTotalCount;
     if (total === 0) return 0;
     const approved = (this.getCompanyCount.availableCompanies || 0) +
                     (this.getCompanyCount.registeredCompanies || 0);
     return Math.round((approved / total) * 100);
   }
 },
  methods: {
   ...mapActions("adminDashboard", ["fetchCompanyCountDetails"]),
  
   async goToBusiness(type) {
     this.loading = true;
     try {
       await this.$router.push({
         name: "admin-company",
         query: { status: type }
       });
     } catch (error) {
       console.error('Navigation error:', error);
     } finally {
       this.loading = false;
     }
   }
 },
  async mounted() {
   this.loading = true;
   try {
     await this.fetchCompanyCountDetails();
   } catch (error) {
     console.error('Error fetching company details:', error);
   } finally {
     this.loading = false;
   }
 }
};
</script>


<style scoped>
.business-card {
 position: relative;
 border-radius: 20px !important;
 overflow: hidden;
 transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
 background: white;
 border: 1px solid rgba(0, 0, 0, 0.05);
 min-height: 350px;
}


.business-card.card-hover {
 transform: translateY(-4px);
 box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}


.card-background {
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 pointer-events: none;
}


.bg-pattern {
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background-image: radial-gradient(circle at 20px 20px, rgba(74, 37, 131, 0.05) 2px, transparent 2px);
 background-size: 40px 40px;
}


.gradient-overlay {
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 height: 120px;
background: linear-gradient(135deg, #254d32 0%, #1e352fb1 100%);
}


.card-header {
 position: relative;
 padding: 24px;
 display: flex;
 align-items: center;
 justify-content: space-between;
 z-index: 1;
}


.header-content {
 display: flex;
 align-items: center;
 gap: 16px;
}


.icon-container {
 width: 56px;
 height: 56px;
 border-radius: 16px;
 background: rgba(255, 255, 255, 0.2);
 display: flex;
 align-items: center;
 justify-content: center;
 backdrop-filter: blur(10px);
}


.header-text {
 color: white;
}


.card-title {
 font-size: 1.5rem;
 font-weight: 700;
 margin: 0 0 4px 0;
}


.card-subtitle {
 font-size: 0.9rem;
 opacity: 0.9;
 margin: 0;
}


.header-decoration {
 display: flex;
 gap: 8px;
}


.deco-circle {
 width: 8px;
 height: 8px;
 border-radius: 50%;
 background: rgb(255 255 255);
 animation: pulse 2s infinite;
}


.deco-circle:nth-child(2) {
 animation-delay: 1s;
}


@keyframes pulse {
 0%, 100% { opacity: 0.3; transform: scale(1); }
 50% { opacity: 1; transform: scale(1.2); }
}


.stats-container {
 padding: 0 24px 24px;
 position: relative;
 z-index: 1;
}


.stats-grid {
 display: grid;
 grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
 gap: 16px;
  margin-bottom: 14px;
}


.stat-card {
 background: white;
 border-radius: 16px;
 padding: 20px;
 cursor: pointer;
 transition: all 0.3s ease;
 border: 1px solid rgba(0, 0, 0, 0.08);
 position: relative;
 overflow: hidden;
 display: flex;
 align-items: center;
 gap: 16px;
}


.stat-card:hover {
 transform: translateY(-2px);
 box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}


.stat-card.stat-hover {
 border-color: currentColor;
}


.stat-icon {
 width: 48px;
 height: 48px;
 border-radius: 12px;
 display: flex;
 align-items: center;
 justify-content: center;
 flex-shrink: 0;
}


.registered-card .stat-icon {
 background: rgba(76, 175, 80, 0.1);
}


.pending-card .stat-icon {
 background: rgba(255, 152, 0, 0.1);
}


.approved-card .stat-icon {
 background: rgba(33, 150, 243, 0.1);
}


.rejected-card .stat-icon {
 background: rgba(244, 67, 54, 0.1);
}


.stat-content {
 flex: 1;
}


.stat-number {
 font-size: 2rem;
 font-weight: 700;
 line-height: 1;
 margin-bottom: 4px;
}


.registered-number {
 color: #4CAF50;
}


.pending-number {
 color: #FF9800;
}


.approved-number {
 color: #2196F3;
}


.rejected-number {
 color: #F44336;
}


.stat-label {
 font-size: 0.9rem;
 color: #666;
 font-weight: 500;
}


.stat-trend {
 position: absolute;
 top: 16px;
 right: 16px;
}


.stat-indicator {
 position: absolute;
 top: 16px;
 right: 16px;
}


.pending-pulse {
 width: 8px;
 height: 8px;
 border-radius: 50%;
 background: #FF9800;
 animation: pulse 2s infinite;
}


.stat-badge {
 position: absolute;
 top: 12px;
 right: 12px;
 background: rgba(33, 150, 243, 0.1);
 color: #2196F3;
 padding: 4px 8px;
 border-radius: 12px;
 font-size: 0.75rem;
 font-weight: 500;
}


.stat-warning {
 position: absolute;
 top: 16px;
 right: 16px;
}


.summary-section {
 padding: 16px 24px;
 background: rgba(0, 0, 0, 0.02);
 display: flex;
 align-items: center;
 gap: 24px;
 border-top: 1px solid rgba(0, 0, 0, 0.05);
}


.summary-item {
 display: flex;
 align-items: center;
 gap: 8px;
}


.summary-text {
 font-size: 0.9rem;
 color: #666;
 font-weight: 500;
}


.view-all-btn {
 margin-left: auto;
 border-radius: 12px !important;
 text-transform: none !important;
 font-weight: 500 !important;
}


.loading-overlay {
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(255, 255, 255, 0.8);
 display: flex;
 align-items: center;
 justify-content: center;
 z-index: 10;
 backdrop-filter: blur(2px);
}


/* Responsive Design */
@media (max-width: 768px) {
 .stats-grid {
   grid-template-columns: repeat(2, 1fr);
 }
  .stat-card {
   padding: 16px;
 }
  .stat-number {
   font-size: 1.5rem;
 }
  .summary-section {
   flex-direction: column;
   gap: 16px;
   align-items: stretch;
 }
  .view-all-btn {
   margin-left: 0;
   align-self: center;
 }
}


@media (max-width: 600px) {
 .stats-grid {
   grid-template-columns: 1fr;
 }
  .card-header {
   padding: 20px;
 }
  .header-content {
   flex-direction: column;
   align-items: flex-start;
   gap: 12px;
 }
  .stats-container {
   padding: 0 20px 20px;
 }
  .summary-section {
   padding: 16px 20px;
 }
  .stat-card {
   flex-direction: column;
   text-align: center;
   gap: 12px;
 }
  .stat-trend,
 .stat-indicator,
 .stat-badge,
 .stat-warning {
   position: static;
 }
}
</style>

